/**
 * UC
 *
 * Changes items with specified CSS class to UserCentrics Links
 */

(function UC() {
    const elements = $('.uc-corner-modal-show');

    /**
     * Create
     */
    function create() {
        $.each(elements, function(index, element) {
            $(element).attr('href', '#uc-corner-modal-show');
        });
    }

    if (elements.length > 0) {
        create();
    }
})();